import { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import ParametroConsulta from "../../../componentes/Autorizaciones/ConsultaRevocaciones/ParametrosConsultaRevocatorias";

export default class ConsultaRevocaciones extends Component {
  render() {
    return (
      <Layout>
        <div>
          <ParametroConsulta />
        </div>
      </Layout>
    );
  }
}
